import { ErrorCode, FileRejection } from 'react-dropzone';
import { IntlShape } from 'react-intl';

import { isVideoFile } from './isVideoFile';

export const getUploadDentalPhotosErrorMessage = (
  fileRejections: FileRejection[],
  formatMessage: IntlShape['formatMessage'],
): string => {
  const firstRejection = fileRejections.at(0);
  const errorCode = firstRejection?.errors.at(0)?.code;
  const file = firstRejection?.file;

  switch (errorCode) {
    case ErrorCode.FileInvalidType:
      return formatMessage({
        id: 'orderReportModal.wrongFile',
        defaultMessage: 'Wrong File(s) format',
      });
    case ErrorCode.FileTooLarge: {
      const isZip = file?.type === 'application/zip';
      const isVideo = file ? isVideoFile(file) : false;

      const maxSize = isZip || isVideo ? '1GB' : '25MB';

      return formatMessage(
        {
          id: 'orderReportModal.sizeError',
          defaultMessage: 'File(s) size must be less than {maxSize}',
        },
        { maxSize },
      );
    }
    default:
      return formatMessage({
        id: 'uploadImage.wrongFile',
        defaultMessage: 'Some files are too large or incorrect format',
      });
  }
};
